import { checkUserHasAdminRole, checkUserHasMasterDataAdminRole } from "app/services/app.state.service"
import AllActivityTypesView from "../master-activity-type/AllActivityTypesView";

export const ActivityTypeRouterFactory = () => {
    if(checkUserHasAdminRole() || checkUserHasMasterDataAdminRole()) {
        return <AllActivityTypesView />
    }

    else {
        window.location.href = "/login";
    } 
}